module.exports = __webpack_public_path__ + "static/media/trial.cc56325.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/trial.mp3
// module id = BOEe
// module chunks = 1 3